module.exports = __webpack_public_path__ + "static/media/circle.373fe3cc.jpg";